

export const products = [
    // Products for Valves
    {
        id: 1,
        name: 'Cast iron wafer check Valve',
        category: 'Valves',
        subcategory: null,
        image: '/image/products/Cast.jpeg',
        alt: 'Cast iron wafer check valve',
        meta: {
            title: 'Cast Iron Wafer Check Valve Sri Lanka | Industrial Backflow Prevention',
            description: "Real Metro Metal offers premium heavy-duty cast iron wafer check valves engineered for superior backflow prevention in demanding industrial piping systems. Our wafer check valves feature a space-saving slim design for seamless installation between flanges, ensuring maximum flow efficiency and long-term durability. Compliant with international quality standards, these valves are the ideal choice for Sri Lankan industrial projects seeking reliable fluid control solutions at competitive wholesale prices.",
            keywords: 'cast iron wafer check valve Sri Lanka, industrial check valve Colombo, pipeline valve supplier, wafer check valve price, iron valve wholesale, heavy-duty check valve Sri Lanka, valve for pipelines, high-quality industrial valve, durable check valve Colombo, cast iron valve supplier'
        }
    },
    {
        id: 2,
        name: 'Check Valve',
        category: 'Valves',
        subcategory: null,
        image: '/image/products/Check.jpeg',
        alt: 'Check valve',
        meta: {
            title: 'Industrial Check Valve Supplier Sri Lanka | Reliable Flow Control',
            description: "Discover high-quality industrial check valves at Real Metro Metal, your trusted supplier in Old Moor Street, Colombo. Our check valves are designed to ensure consistent unidirectional flow and prevent costly backflow in various plumbing and industrial applications. Built with durable materials to withstand high pressure, these reliable valves provide long-lasting performance for irrigation, manufacturing, and construction projects across Sri Lanka with guaranteed quality and competitive pricing.",
            keywords: 'check valve Sri Lanka, unidirectional valve Colombo, backflow prevention valves, industrial check valve supplier, reliable valve Colombo, efficient check valve price, valve for pumps Sri Lanka, plumbing check valve, durable check valve, mechanical check valve Colombo'
        }
    },
    {
        id: 3,
        name: 'Stainless Steel 3 Piece Ball Valve',
        category: 'Valves',
        subcategory: null,
        image: '/image/products/steel.jpeg',
        alt: 'Stainless steel 3 piece ball valve',
        meta: {
            title: 'Stainless Steel 3 Piece Ball Valve | Precision Industrial Control',
            description: "Upgrade your industrial piping with our stainless steel 3-piece ball valves, designed for precision control and exceptional durability. Real Metro Metal provides premium SS ball valves that offer easy maintenance and superior corrosion resistance for chemical, pharmaceutical, and food processing industries in Sri Lanka. These valves ensure a leak-proof seal and smooth operation, making them a reliable choice for critical flow management in any professional hardware application.",
            keywords: 'stainless steel ball valve Sri Lanka, 3 piece ball valve Colombo, precision control valve, industrial ball valve price, durable ball valve Sri Lanka, stainless steel valve wholesale, high-quality ball valve, valve for pipes, metal ball valve Colombo, reliable ball valve supplier'
        }
    },
    {
        id: 4,
        name: 'SS mesh',
        category: 'Mesh',
        subcategory: 'SS Mesh',
        image: '/image/products/ssmesh.jpeg',
        alt: 'Stainless steel mesh',
        meta: {
            title: 'Stainless Steel Mesh - Durable and Versatile',
            description: 'Explore our stainless steel mesh products, ideal for filtration, reinforcement, and various industrial applications.',
            keywords: 'stainless steel mesh, mesh for filtration, industrial mesh, SS mesh, durable mesh, versatile mesh, stainless steel wire mesh, reinforcement mesh, high-quality mesh, mesh for construction'
        }
    },
    {
        id: 5,
        name: 'H Beam',
        category: 'H-Iron',
        subcategory: null,
        image: '/image/products/Hbeam.jpeg',
        alt: 'H beam',
        meta: {
            title: 'H-Beam Structural Steel | Heavy-Duty Construction Support Sri Lanka',
            description: "Real Metro Metal supplies high-strength structural H-beams designed for heavy-duty support in large-scale construction projects across Sri Lanka. Our H-iron beams offer superior load-bearing capacity for columns and framework in both industrial warehouses and commercial building complexes. Sourced from top manufacturers, these beams ensure structural integrity and long-term stability for your infrastructure, available for reliable delivery from our Old Moor Street warehouse in Colombo.",
            keywords: 'H beam Sri Lanka, structural steel beam Colombo, construction beam price, building support beam Sri Lanka, heavy-duty H-iron, steel beam wholesale, industrial beam Colombo, high-strength beam Sri Lanka, beam for construction, H section beam price'
        }
    },
    {
        id: 6,
        name: 'Channel Bar',
        category: 'Boxbars',
        subcategory: null,
        image: '/image/products/ChannelBar.jpeg',
        alt: 'Industrial steel channel bar for construction Sri Lanka',
        meta: {
            title: 'Channel Bar | Versatile Steel Channels for Manufacturing',
            description: 'Find high-quality channel bars for various construction and manufacturing needs. Ideal for structural support and framing in industrial projects.',
            keywords: 'channel bar, steel channel, construction channel, framing channel, structural channel, industrial channel, versatile channel bar, metal channel, high-quality channel bar, channel section'
        }
    },
    {
        id: 7,
        name: 'C-PURLINS',
        category: 'Boxbars',
        subcategory: null,
        image: '/image/products/cperlin.jpeg',
        alt: 'C-purlins',
        meta: {
            title: 'C-PURLINS - Structural Steel Purlins',
            description: 'Shop for C-purlins used in structural framing and support. Provides strength and durability for roof and wall applications.',
            keywords: 'C-purlins, structural purlins, steel purlins, roofing purlins, wall purlins, durable purlins, industrial purlins, metal purlins, C section purlins, framing purlins'
        }
    },
    {
        id: 8,
        name: 'SS shim sheets',
        category: 'Plates & Sheets',
        subcategory: 'SS Shim Sheets',
        image: '/image/products/ssshimsheets.jpeg',
        alt: 'Stainless steel shim sheets',
        meta: {
            title: 'SS Shim Sheets - Precision Shims for Machinery',
            description: 'Purchase stainless steel shim sheets for precise adjustments and alignment in machinery and equipment.',
            keywords: 'SS shim sheets, stainless steel shims, precision shim sheets, machinery shims, equipment shims, durable shim sheets, high-quality shims, metal shim sheets, shim material, industrial shim sheets'
        }
    },
    {
        id: 9,
        name: 'Embossed Stainless Steel Sheet',
        category: 'Plates & Sheets',
        subcategory: null,
        image: '/image/products/embossed.jpeg',
        alt: 'Decorative embossed stainless steel sheet for interior design',
        meta: {
            title: 'Embossed SS Sheet - Decorative & Durable',
            description: 'Explore embossed stainless steel sheets for decorative and functional applications. Perfect for interior design and industrial uses.',
            keywords: 'embossed stainless steel sheet, decorative steel sheet, durable steel sheet, stainless steel with embossing, industrial steel sheet, high-quality embossed sheet, metal sheets, interior design sheet, embossed metal, steel sheet for decor'
        }
    },
    {
        id: 10,
        name: 'GI Pipe Fittings',
        category: 'Valves',
        subcategory: null,
        image: '/image/products/GI_pipe_fittings.jpeg',
        alt: 'GI pipe fittings supplier Sri Lanka',
        meta: {
            title: 'GI Pipe Fittings - Reliable and Durable',
            description: 'Find GI pipe fittings for a variety of plumbing and construction needs. Offers reliability and durability in pipe connections.',
            keywords: 'GI pipe fittings, galvanized pipe fittings, plumbing fittings, durable pipe fittings, GI plumbing fittings, metal pipe fittings, industrial pipe fittings, high-quality pipe fittings, pipe connectors, galvanized fittings'
        }
    },
    {
        id: 11,
        name: 'Stainless Steel Pipe Fittings',
        category: 'Valves',
        subcategory: null,
        image: '/image/products/stainlesssteel.jpeg',
        alt: 'Premium stainless steel pipe fittings supplier Sri Lanka',
        meta: {
            title: 'SS Pipe Fittings for Industrial Use | High-Quality Connections',
            description: "We offer a comprehensive range of steel fittings including elbows, tees, reducers, and flanges. Our products are suitable for plumbing, industrial systems, and construction projects requiring strong and leak-proof connections.",
            keywords: 'stainless steel pipe fittings Sri Lanka, industrial SS fittings, high-quality metal fittings, industrial connectors Colombo, durable pipe fittings Sri Lanka, steel fittings wholesale, plumbing fittings Colombo, stainless steel connectors, pipe joints Sri Lanka, reliable SS fittings'
        }
    },
    {
        id: 12,
        name: 'Stainless Steel Pipe Fittings',
        category: 'Valves',
        subcategory: null,
        image: '/image/products/stainless.jpeg',
        alt: 'Corrosion-resistant stainless steel pipe fittings Colombo',
        meta: {
            title: 'Corrosion-Resistant SS Pipe Fittings | Reliable and Strong',
            description: "Explore our range of corrosion-resistant stainless steel pipe fittings, ideal for maintaining strong and reliable connections in harsh industrial environments. Real Metro Metal specializes in providing heavy-duty SS fittings that meet international standards for strength and durability. Whether you are working on a large-scale construction project or a specialized industrial setup in Sri Lanka, our fittings deliver the high-performance connectivity you need.",
            keywords: 'corrosion resistant SS fittings, industrial pipe fittings Sri Lanka, reliable SS connectors, strong pipe fittings Colombo, steel pipe fittings price, high-performance metal fittings, metal pipe fittings Sri Lanka, plumbing connections Colombo, stainless steel connectors, durable pipe fittings supplier'
        }
    },
    {
        id: 13,
        name: 'Stainless Steel Pipe Fittings',
        category: 'Valves',
        subcategory: null,
        image: '/image/products/stain.jpeg',
        alt: 'High-quality stainless steel pipe fittings for industrial systems',
        meta: {
            title: 'Premium Quality Stainless Steel Pipe Fittings Colombo',
            description: "Find premium quality stainless steel pipe fittings at Real Metro Metal, your trusted source in Colombo for high-end industrial hardware. Our SS fittings are precision-engineered to ensure a perfect seal and long-lasting reliability in any application. From industrial boilers to water treatment plants, our premium stainless steel components provide the structural integrity required for critical infrastructure projects across Sri Lanka at competitive wholesale rates.",
            keywords: 'premium SS pipe fittings, high-quality pipe fittings Sri Lanka, durable stainless steel fittings, industrial pipe fittings Colombo, steel connectors wholesale, plumbing fittings price, reliable pipe joints Sri Lanka, metal pipe fittings Colombo, stainless steel hardware, SS components Sri Lanka'
        }
    },
    {
        id: 14,
        name: 'Stainless Steel Pipe Fittings',
        category: 'Valves',
        subcategory: null,
        image: '/image/products/stain2.jpeg',
        alt: 'Durable stainless steel connectors and components Sri Lanka',
        meta: {
            title: 'Versatile Stainless Steel Fittings | Durable SS Components',
            description: "Real Metro Metal offers a versatile selection of durable stainless steel pipe fittings suitable for a wide array of plumbing and industrial needs in Sri Lanka. Our SS fittings are designed for flexibility and ease of installation, providing a secure and leak-proof solution for both residential and commercial projects. Experience the strength of premium stainless steel with our high-quality connectors and components, available now at our Colombo warehouse.",
            keywords: 'versatile SS fittings, durable stainless steel components, industrial pipe fittings Sri Lanka, plumbing fittings Colombo, steel pipe fittings wholesale, high-quality connectors, stainless steel components price, reliable pipe fittings Sri Lanka, metal fittings Colombo, SS hardware supplier'
        }
    },
    {
        id: 15,
        name: 'Kraloy Access Fitting - LB Type - 2-in - PVC - Grey',
        category: 'GI Conduits & Fittings',
        subcategory: null,
        image: '/image/products/fit.jpeg',
        alt: 'Kraloy access fitting - LB type - 2-in - PVC - Grey now available',
        meta: {
            title: 'Kraloy Access Fitting - LB Type - PVC - 2-in Grey',
            description: 'Buy Kraloy LB Type access fittings in PVC for reliable electrical conduit connections. Available in 2-in and grey.',
            keywords: 'Kraloy access fitting, LB type fitting, PVC access fitting, 2-inch conduit fitting, grey conduit fitting, electrical fitting, durable access fitting, GI conduit accessories, high-quality fitting, reliable conduit fitting'
        }
    },
    {
        id: 16,
        name: 'Wedge Anchor',
        category: 'Nuts & Bolts',
        subcategory: null,
        image: '/image/products/nut1.jpeg',
        alt: 'Wedge anchor now available',
        meta: {
            title: 'Wedge Anchor - Secure and Reliable',
            description: 'Find wedge anchors for secure fastening and reliable performance in concrete and masonry applications.',
            keywords: 'wedge anchor, concrete anchor, masonry anchor, secure fastening, reliable anchor, industrial wedge anchor, high-strength anchor, metal anchor, wedge anchor for construction, fastening solutions'
        }
    },
    {
        id: 17,
        name: 'Electrical Metallic Tubing (EMT)',
        category: 'GI Conduits & Fittings',
        subcategory: null,
        image: '/image/products/emt.jpeg',
        alt: 'Electrical metallic tubing (EMT) now available',
        meta: {
            title: 'Electrical Metallic Tubing (EMT) - Durable',
            description: 'Purchase electrical metallic tubing (EMT) for efficient conduit solutions. Durable and versatile for various electrical installations.',
            keywords: 'electrical metallic tubing, EMT, conduit tubing, durable EMT, versatile EMT, electrical conduit, metal tubing, industrial tubing, high-quality EMT, EMT for electrical installations'
        }
    },
    {
        id: 18,
        name: 'EMT COUPLINGS',
        category: 'GI Conduits & Fittings',
        subcategory: null,
        image: '/image/products/emt1.jpeg',
        alt: 'EMT couplings now available',
        meta: {
            title: 'EMT Couplings - Reliable and Efficient',
            description: 'Explore EMT couplings for reliable and efficient connections in electrical conduit systems. Ensures secure fittings and durable performance.',
            keywords: 'EMT couplings, electrical couplings, conduit couplings, reliable couplings, efficient couplings, metal couplings, durable conduit fittings, high-quality couplings, EMT fittings, secure couplings'
        }
    },
    {
        id: 19,
        name: 'Skypark Case Study',
        category: 'GI Conduits & Fittings',
        subcategory: null,
        image: '/image/products/skypark.jpeg',
        alt: 'Skypark case study now available',
        meta: {
            title: 'Skypark Case Study - GI Conduit Solutions',
            description: 'Read the Skypark case study to learn about innovative GI conduit solutions and their impact on construction and design.',
            keywords: 'Skypark case study, GI conduit solutions, innovative construction, conduit design, case study, construction solutions, industrial design, GI conduits, high-quality conduits, construction impact'
        }
    },
    {
        id: 20,
        name: 'Hallowell Pallet Racking Shelf Clips',
        category: 'GI Conduits & Fittings',
        subcategory: null,
        image: '/image/products/hallowel.jpeg',
        alt: 'Hallowell pallet racking shelf clips now available',
        meta: {
            title: 'Hallowell Racking Clips - Secure Storage',
            description: 'Find Hallowell pallet racking shelf clips for secure and adjustable shelf storage solutions in racking systems.',
            keywords: 'Hallowell pallet racking clips, shelf clips, racking shelf clips, secure storage solutions, pallet racking accessories, adjustable shelf clips, high-quality clips, industrial shelf clips, metal shelf clips, racking system components'
        }
    },
    {
        id: 21,
        name: 'Bold and efficient xcc ceiling clip',
        category: 'GI Conduits & Fittings',
        subcategory: null,
        image: '/image/products/bolt.jpeg',
        alt: 'Bold and efficient xcc ceiling clip now available',
        meta: {
            title: 'XCC Ceiling Clip - High-Performance',
            description: 'Shop for bold and efficient XCC ceiling clips designed for high-performance ceiling installations and fixtures.',
            keywords: 'XCC ceiling clip, ceiling installation clip, high-performance clip, bold ceiling clip, efficient ceiling fixture, ceiling hardware, industrial ceiling clip, metal ceiling clip, durable ceiling clip, ceiling installation solutions'
        }
    },
    {
        id: 22,
        name: 'Bridgeport Black Conduit Fittings',
        category: 'GI Conduits & Fittings',
        subcategory: null,
        image: '/image/products/Bridgeport.jpeg',
        alt: 'Bridgeport black conduit fittings for sale',
        meta: {
            title: 'Bridgeport Black Conduit Fittings - Durable',
            description: 'Discover Bridgeport black conduit fittings for durable and reliable conduit connections in electrical systems.',
            keywords: 'Bridgeport conduit fittings, black conduit fittings, durable conduit, reliable fittings, electrical conduit fittings, high-quality conduit fittings, metal conduit fittings, industrial conduit fittings, conduit accessories, black fittings'
        }
    },
    {
        id: 23,
        name: 'FMC 90° angle',
        category: 'GI Conduits & Fittings',
        subcategory: null,
        image: '/image/products/fmc.jpeg',
        alt: 'FMC 90° angle in offer',
        meta: {
            title: 'FMC 90° Angle - High-Quality Conduit Fittings',
            description: 'Find FMC 90° angle fittings for efficient conduit installations and connections. Ideal for various electrical applications.',
            keywords: 'FMC 90° angle, conduit angle fitting, 90-degree angle fitting, conduit connections, electrical fittings, high-quality angle fitting, industrial conduit fitting, metal angle fitting, conduit accessories, efficient conduit fittings'
        }
    },
    {
        id: 24,
        name: 'Track Shoe Bolt & Square Nut',
        category: 'Nuts & Bolts',
        subcategory: null,
        image: '/image/products/shoenut.jpeg',
        alt: 'Nuts & Bolts Track Shoe Bolt & Square Nut for sale',
        meta: {
            title: 'Track Shoe Bolt & Square Nut - Durable Fasteners',
            description: 'Shop for track shoe bolts and square nuts designed for durability and strength in fastening applications.',
            keywords: 'track shoe bolt, square nut, durable fasteners, industrial bolts, high-strength nuts, metal fasteners, reliable bolts, fastening solutions, track shoe accessories, square nuts for construction'
        }
    },
    {
        id: 25,
        name: 'H-Iron',
        category: 'H-Iron',
        subcategory: null,
        image: '/image/products/hiron.jpeg',
        alt: 'Heavy-duty H-iron structural steel beam Colombo',
        meta: {
            title: 'H-Iron - Structural Steel Beams',
            description: 'Purchase H-Iron beams for robust structural support in construction projects. Ideal for heavy-duty applications.',
            keywords: 'H-Iron, structural steel beams, construction beams, heavy-duty beams, H-Iron beams, metal beams, industrial beams, steel beams, high-strength beams, construction support'
        }
    },
    {
        id: 26,
        name: 'Stainless Steel H Beam',
        category: 'H-Iron',
        subcategory: null,
        image: '/image/products/sshbeam.jpeg',
        alt: 'Stainless steel H beam for corrosion-resistant construction',
        meta: {
            title: 'Stainless Steel H Beam - Structural Steel',
            description: 'Find stainless steel H beams for strong and durable structural support. Perfect for various construction and industrial applications.',
            keywords: 'stainless steel H beam, structural steel, H beam, high-quality steel beam, durable H beam, construction beam, stainless steel construction, industrial steel beam, metal H beam, strong beam'
        }
    },
    {
        id: 27,
        name: 'Stainless Steel Rod',
        category: 'Pipes',
        subcategory: 'SS Pipes',
        image: '/image/products/ssrod.jpeg',
        alt: 'Stainless steel rod supplier Sri Lanka',
        meta: {
            title: 'Stainless Steel Rod | High-Strength Industrial Materials',
            description: 'Our stainless steel rods are designed for durability and high performance in industrial and construction applications. Real Metro Metal provides reliable supply solutions across Sri Lanka, supporting projects of all sizes with consistent quality and competitive pricing.',
            keywords: 'stainless steel rod, precision rod, durable rod, industrial rod, metal rod, construction rod, stainless steel material, high-strength rod, SS rod, manufacturing rod'
        }
    },
    {
        id: 28,
        name: 'Stainless Steel Channels',
        category: null,
        subcategory: 'SS Pipes',
        image: '/image/products/sschannel.jpeg',
        alt: 'Industrial stainless steel channels for structural support',
        meta: {
            title: 'Stainless Steel Channels - Versatile and Durable',
            description: 'Explore stainless steel channels for versatile and durable use in various structural and industrial applications.',
            keywords: 'stainless steel channels, SS channels, structural channels, durable channels, industrial channels, metal channels, versatile channels, high-quality channels, stainless steel construction, channel steel'
        }
    },
    {
        id: 29,
        name: 'Mild Steel Round',
        category: 'Pipes',
        subcategory: 'MS Pipes',
        image: '/image/products/midsteel.jpeg',
        alt: 'Mild steel round pipes for industrial fabrication Sri Lanka',
        meta: {
            title: 'Mild Steel Round - High-Quality MS Pipes',
            description: 'Purchase mild steel round pipes for construction and manufacturing needs. Offers strength and flexibility for various applications.',
            keywords: 'mild steel round, MS pipes, construction pipes, mild steel pipes, round metal pipes, industrial pipes, high-quality steel pipes, durable round pipes, metal round pipes, MS round pipes'
        }
    },
    {
        id: 30,
        name: 'GI Box Bar',
        category: 'Boxbars',
        subcategory: 'GI Boxbars',
        image: '/image/products/giboxbar.jpeg',
        alt: 'GI Box Bar',
        meta: {
            title: 'GI Box Bar | Galvanized Square & Rectangular Tubes Sri Lanka',
            description: "Find high-quality GI box bars at Real Metro Metal, perfect for construction and industrial applications requiring superior corrosion resistance. Our galvanized box bars are available in various sizes and thicknesses, providing durable structural support for roofing, fencing, and framework. As a leading supplier in Colombo, we ensure our GI box bars meet stringent quality standards while offering competitive wholesale pricing and reliable island-wide delivery for all your building projects.",
            keywords: 'GI box bar Sri Lanka, galvanized box bar Colombo, construction box bar price, industrial box bar supplier, durable GI bar, metal box bar wholesale, GI tubing Sri Lanka, high-quality galvanized bar, galvanized steel bar price, box bar for construction Colombo'
        }
    },
    {
        id: 31,
        name: 'STAINLESS STEEL Box Bar',
        category: 'Boxbars',
        subcategory: 'SS Boxbars',
        image: '/image/products/ssboxbar.jpeg',
        alt: 'Strong stainless steel box bar for structural applications',
        meta: {
            title: 'Stainless Steel Box Bar - Strong and Durable',
            description: 'Shop for stainless steel box bars, offering strength and durability for various industrial and structural applications.',
            keywords: 'stainless steel box bar, SS box bar, durable box bar, strong box bar, metal box bar, industrial box bar, high-quality box bar, stainless steel bar, construction box bar, steel box bar'
        }
    },
    {
        id: 32,
        name: 'Gate Valve',
        category: 'Valves',
        subcategory: null,
        image: '/image/products/gatevalve.jpeg',
        alt: 'Industrial gate valve for reliable fluid control Colombo',
        meta: {
            title: 'Gate Valve - Reliable Flow Control',
            description: 'Find gate valves for efficient flow control in various applications. Ideal for on-off control in piping systems.',
            keywords: 'gate valve, flow control valve, piping valve, on-off valve, industrial valve, reliable gate valve, metal valve, high-quality gate valve, durable valve, valve for pipelines'
        }
    },
    {
        id: 33,
        name: 'Mild Steel Plate',
        category: 'Plates & Sheets',
        subcategory: 'MS Plates & Sheets',
        image: '/image/products/msplate.jpeg',
        alt: 'Mild Steel Plate',
        meta: {
            title: 'Mild Steel Plate | Heavy-Duty MS Plate Supplier Sri Lanka',
            description: "Real Metro Metal provides superior quality mild steel plates in various thicknesses, ideal for structural fabrication, machining, and industrial base plates. Our MS plates are known for high weldability and formability, making them the preferred choice for engineering projects across Sri Lanka. Located in Old Moor Street, Colombo, we stock a vast inventory of mild steel sheets and plates to meet the immediate needs of contractors and manufacturers with guaranteed durability.",
            keywords: 'mild steel plate Sri Lanka, MS plate Colombo, construction plate price, industrial plate supplier, durable steel plate wholesale, metal plate Sri Lanka, versatile MS plate, high-quality mild steel, MS sheet price Colombo, steel for construction Sri Lanka'
        }
    },
    {
        id: 34,
        name: 'Mild Steel Plate',
        category: 'Plates & Sheets',
        subcategory: 'SS Plates & Sheets',
        image: '/image/products/ssplate.jpeg',
        alt: 'High-quality stainless steel plate for industrial manufacturing',
        meta: {
            title: 'Stainless Steel Plate - High-Quality and Durable',
            description: 'Find stainless steel plates for high-quality and durable applications in various industries.',
            keywords: 'stainless steel plate, SS plate, durable plate, high-quality steel plate, industrial plate, metal plate, stainless steel sheet, versatile steel plate, construction plate, steel for manufacturing'
        }
    },
    {
        id: 35,
        name: 'GI Plate',
        category: 'Plates & Sheets',
        subcategory: 'GI Plates & Sheets',
        image: '/image/products/giplate.jpeg',
        alt: 'GI Plate',
        meta: {
            title: 'GI Plate Sri Lanka | Galvanized Steel Sheet Supplier Colombo',
            description: "Explore our range of GI plates at Real Metro Metal, offering exceptional durability and corrosion resistance for demanding industrial and construction environments. These galvanized steel sheets are suitable for outdoor structures, industrial flooring, and heavy-duty fabrication where protection against rust is critical. We provide GI plates in multiple specifications, ensuring Sri Lankan industries have access to reliable, high-quality metal products that stand the test of time in tropical climates.",
            keywords: 'GI plate Sri Lanka, galvanized steel plate Colombo, durable GI sheet, industrial GI plate price, metal GI plate supplier, construction GI sheet, high-quality GI plate Colombo, corrosion-resistant steel, GI steel sheet price, GI steel supplier Sri Lanka'
        }
    },
    {
        id: 36,
        name: 'Aluminium Sheet',
        category: 'Plates & Sheets',
        subcategory: 'Aluminium Plates & Sheets',
        image: '/image/products/alumuniumsheet.jpeg',
        alt: 'Lightweight aluminium sheet for construction and design',
        meta: {
            title: 'Aluminium Sheet - Lightweight and Strong',
            description: 'Find aluminium sheets that are lightweight yet strong, ideal for various applications from construction to manufacturing.',
            keywords: 'aluminium sheet, lightweight sheet, strong aluminium sheet, metal sheet, industrial aluminium sheet, construction aluminium sheet, high-quality aluminium, versatile sheet, aluminium plate, durable sheet'
        }
    },
    {
        id: 37,
        name: 'Aluminium Checker Plate',
        category: 'Plates & Sheets',
        subcategory: 'Aluminium Plates & Sheets',
        image: '/image/products/alumuniumcheckerplate.jpeg',
        alt: 'Anti-slip aluminium checker plate for industrial flooring',
        meta: {
            title: 'Aluminium Checker Plate - Durable and Stylish',
            description: 'Discover our aluminium checker plates, offering both durability and a stylish checkered pattern suitable for various applications including flooring and construction.',
            keywords: 'aluminium checker plate, durable checker plate, stylish checker plate, industrial aluminium plate, flooring plate, construction plate, aluminium plate, high-quality checker plate, versatile aluminium checker, metal checker plate'
        }
    },
    {
        id: 38,
        name: 'Adjustable Scaffolding Props',
        category: 'Scaffolding',
        subcategory: null,
        image: '/image/products/scaffolding_props.png',
        alt: 'Adjustable steel scaffolding props',
        meta: {
            title: 'Adjustable Scaffolding Props - Construction',
            description: 'High-quality adjustable steel scaffolding props for reliable structural support in construction. Durable, galvanized, and easy to adjust.',
            keywords: 'scaffolding props, adjustable shore props, steel props, construction support, telescopic props, heavy-duty scaffolding, galvanized steel props, formwork support, building support, adjustable steel columns'
        }
    },
    {
        id: 39,
        name: 'Color-Coded Wire Connectors',
        category: 'GI Conduits & Fittings',
        subcategory: 'Electrical Connectors',
        image: '/image/products/wire_connectors.png',
        alt: 'Color-coded twist-on wire connectors',
        meta: {
            title: 'Wire Connectors - Secure Electrical Connections',
            description: 'Reliable twist-on wire connectors in various sizes and colors. Perfect for secure electrical wiring and circuit connections.',
            keywords: 'wire connectors, wire nuts, twist-on connectors, electrical connectors, color-coded wire nuts, secure wiring, electrical fittings, terminal connectors, AWG wire connectors, electrical hardware'
        }
    },
];

/*
// Products for GI Conduits & Fittings
{ id: 3, name: 'GI Conduit A', category: 'GI Conduits & Fittings', subcategory: null, image: '/image/products/valve.jpg' },
{ id: 4, name: 'GI Fitting B', category: 'GI Conduits & Fittings', subcategory: null, image: '/image/products/valve.jpg' },

// Products for Nuts & Bolts
{ id: 5, name: 'Nut A1', category: 'Nuts & Bolts', subcategory: null, image: '/image/products/valve.jpg' },
{ id: 6, name: 'Bolt B1', category: 'Nuts & Bolts', subcategory: null, image: '/image/products/valve.jpg' },

// Products for H-Iron
{ id: 7, name: 'MS H-Iron 1', category: 'H-Iron', subcategory: 'MS H-Iron', image: '/image/products/valve.jpg' },
{ id: 8, name: 'GI H-Iron 1', category: 'H-Iron', subcategory: 'GI H-Iron', image: '/image/products/valve.jpg' },

// Products for Boxbars
{ id: 9, name: 'MS Boxbar 1', category: 'Boxbars', subcategory: 'MS Boxbars', image: '/image/products/valve.jpg' },
{ id: 10, name: 'GI Boxbar 1', category: 'Boxbars', subcategory: 'GI Boxbars', image: '/image/products/valve.jpg' },
{ id: 11, name: 'SS Boxbar 1', category: 'Boxbars', subcategory: 'SS Boxbars', image: '/image/products/valve.jpg' },

// Products for Pipes
{ id: 12, name: 'GI Pipe 1', category: 'Pipes', subcategory: 'GI Pipes', image: '/image/products/valve.jpg' },
{ id: 13, name: 'MS Pipe 1', category: 'Pipes', subcategory: 'MS Pipes', image: '/image/products/valve.jpg' },
{ id: 14, name: 'SS Pipe 1', category: 'Pipes', subcategory: 'SS Pipes', image: '/image/products/valve.jpg' },
{ id: 15, name: 'Aluminium Pipe 1', category: 'Pipes', subcategory: 'Aluminium Pipes', image: '/image/products/valve.jpg' },

// Products for Plates & Sheets
{ id: 16, name: 'MS Plate 1', category: 'Plates & Sheets', subcategory: 'MS Plates & Sheets', image: '/image/products/valve.jpg' },
{ id: 17, name: 'SS Sheet 1', category: 'Plates & Sheets', subcategory: 'SS Plates & Sheets', image: '/image/products/valve.jpg' },
{ id: 18, name: 'GI Plate 1', category: 'Plates & Sheets', subcategory: 'GI Plates & Sheets', image: '/image/products/valve.jpg' },
{ id: 19, name: 'Imported Plate 1', category: 'Plates & Sheets', subcategory: 'Imported Plates & Sheets', image: '/image/products/valve.jpg' },
{ id: 20, name: 'Zincalume Sheet 1', category: 'Plates & Sheets', subcategory: 'Zincalume Plates & Sheets', image: '/image/products/valve.jpg' },
{ id: 21, name: 'Aluminium Plate 1', category: 'Plates & Sheets', subcategory: 'Aluminium Plates & Sheets', image: '/image/products/valve.jpg' },

*/

